import { HIDDEN_BALANCES_FULL_TEXT } from '@/shared/config';
import { cn } from '@/shared/utils';

type Props = {
  isBalancesHidden: boolean;
  valueText: string;
  suffix: string;
  valueClassName?: string;
};

const TradingAssetAmount = ({
  isBalancesHidden,
  valueText,
  suffix,
  valueClassName,
}: Props) => (
  <span
    className={cn(
      'medium5 text-primary whitespace-nowrap text-end',
      valueClassName
    )}>
    {isBalancesHidden ? HIDDEN_BALANCES_FULL_TEXT : valueText} {suffix}
  </span>
);

export { TradingAssetAmount };
